import "./CustomLoader.css";

interface CustomLoaderInterFace {
  message: string;
}

const CustomLoader = (props: CustomLoaderInterFace) => {
  const { message } = props;
  return (
    <div>
      <div
        className="position-fixed custom-loader w-100 h-100 d-flex justify-content-center align-items-center"
     
      >
        <div className="text-center text-white">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <div className="mt-2">{message}</div>
        </div>
      </div>
    </div>
  );
};

export default CustomLoader;
